export default __webpack_public_path__ + "static/Content-image-566cb2caba1e18388b0a625304adf525.webp";